/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/promotion';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "RetrievePromotionRequest": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrievePromotionResponse": {
                    "fields": {
                      "promotion": {
                        "type": "squareup.solidshop.v2.resources.PromotionRetrieved",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.RetrievePromotionRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.RetrievePromotionResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE RetrievePromotionRequest @ squareup/solidshop/v2/service/promotions/retrieve_promotion.proto at 11:1
 */
export const RetrievePromotionRequest = $root.lookupType('squareup.solidshop.v2.service.RetrievePromotionRequest');
fixType(RetrievePromotionRequest);
Builder.createAndAttachToType(RetrievePromotionRequest);
/**
 * SOURCE RetrievePromotionResponse @ squareup/solidshop/v2/service/promotions/retrieve_promotion.proto at 15:1
 */
export const RetrievePromotionResponse = $root.lookupType('squareup.solidshop.v2.service.RetrievePromotionResponse');
fixType(RetrievePromotionResponse);
Builder.createAndAttachToType(RetrievePromotionResponse);
